<template>
  <overlay
    key="details"
    block-class="product-details-drawer"
    direction="left"
    namespace="details"
    type="drawer"
  >
    <template #body>
      <div class="main-product product-details-drawer__body">
        <div class="product-details-drawer__content">
          <responsive-image
            v-if="product.media.length > 0"
            :image="product.media[0].image"
            min-max="600-1000"
            ratio="4:3"
          />
          <div class="product-details-drawer__footer">
            <main-product-sidebar-header
              :is-desktop="!isMobile"
              :product="product"
              :variant="variant"
            />
            <div class="main-product__form">
              <product-form
                :product="product"
                :variant="variant"
                @update-variant="updateVariant"
              />
            </div>
          </div>
        </div>
      </div>
    </template>
  </overlay>
</template>

<script>

/**
 * Vue: product-details-drawer (product-details-drawer)
 * -----------------------------------------------------------------------------
 * product details drawer.
 *
 */
import { mapActions, mapState } from 'vuex'
import MainProductSidebarHeader from '~async/main-product/main-product-sidebar-header.vue'
import Overlay from '~global/overlay/overlay'
import ProductForm from '~async/product-form/product-form'
import ResponsiveImage from '~global/images/responsive-image'
export default {
  name: 'ProductDetailsDrawer',
  components: {
    MainProductSidebarHeader,
    Overlay,
    ProductForm,
    ResponsiveImage,
  },
  props: {
    product: {
      type: Object,
      default: () => ({
      }),
    },
  },
  data() {
    return {
      variant: false,
    }
  },
  computed: {

    /**
     * Map Vuex state.
     */
    ...mapState({
      isMobile: (state) => state.index.screen.mobile,
    }),
  },
  watch: {
    // not empty
  },
  mounted() {
    this.variant = this.product.variants[0]

    this.openOverlay({
      ignoreDismissed: true,
      namespace: 'details',
    })
  },

  methods: {

    /**
     * Map Vuex actions.
     */
    ...mapActions({
      openOverlay: 'overlays/open',
      closeOverlay: 'overlays/close',
    }),

    updateVariant(variant) {
      this.variant = variant
    },
  },
}
</script>

<style lang="scss">
@import './product-details-drawer';
@import '../main-product/main-product';
</style>
